import {
	jobProfileResponsibilityDelete,
	jobProfileResponsibilityGet,
} from "#job-profile/services/api"
import JobProfileItem from "../JobProfileItem"
import { JobProfileResponsibilitiesFormDialog } from "./JobProfileResponsibilitiesForm"

export default function JobProfileResponsibilities({
	profileId,
	autoFetch = true,
	noEdit,
}) {
	const items = [
		{
			name: "name",
			label: "Descripción",
			props: {},
		},
	]

	return (
		<JobProfileItem
			key="responsibilities"
			{...{
				profileId,
				autoFetch,
				tableItems: items,
				apiGet: jobProfileResponsibilityGet,
				apiDelete: jobProfileResponsibilityDelete,
				name: "",
				messageDelete: (responsibility) => (
					<>
						¿Estas seguro de eliminar la responsabilidad
						<strong> {responsibility.name}</strong>?
					</>
				),
				AddForm: JobProfileResponsibilitiesFormDialog,
				noEdit,
			}}
		/>
	)
}
